import { render, staticRenderFns } from "./client-profile-campaigns.vue?vue&type=template&id=6c3ad215"
import script from "./client-profile-campaigns.vue?vue&type=script&lang=js"
export * from "./client-profile-campaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports